export const tabs = {
	OPERATIONS: 'OPERATIONS',
	FLEET_MANAGER: 'FLEET_MANAGER',
	DASHBOARD: 'DASHBOARD',
};